import { QueryCacheEnum } from 'constants/ReactQuery.constants'
import { Maybe } from '@vendorflow/types'
import { useQuery } from '@tanstack/react-query'
import { Tenant_Endpoints_Addresses_Config } from 'features/tenants-endpoints-addresses/TenantsEndpointsAddresses.types'
import { generateTenantConfigBasedOnPolicy } from 'features/tenants-endpoints-addresses/TenantsEndpointsAddresses.services'
import { useMyOrgId } from 'queries/Auth.queries'
import ms from 'ms'

export function tenantConfigQueryKey(tenant: Maybe<string>) {
  return [QueryCacheEnum.TENANTS, tenant]
}

export async function tenantConfigQueryFn({
  queryKey,
}: {
  queryKey: ReturnType<typeof tenantConfigQueryKey>
}): Promise<Tenant_Endpoints_Addresses_Config> {
  const tenant = queryKey[1]!
  return generateTenantConfigBasedOnPolicy(tenant)
}

export function useTenantConfig() {
  const envy = useMyOrgId()

  return useQuery<
    Tenant_Endpoints_Addresses_Config,
    Error,
    Tenant_Endpoints_Addresses_Config,
    ReturnType<typeof tenantConfigQueryKey>
  >({
    queryKey: tenantConfigQueryKey(envy),
    queryFn: tenantConfigQueryFn,
    enabled: Boolean(envy),
    staleTime: ms('6h'),
    cacheTime: ms('6h'),
  })
}
